module.exports = {
    locales: ["cs", "sk", "en"],
    defaultLocale: process.env.DEFAULT_LANGUAGE,
    logBuild: false,
    pages: require("./i18n-pages.json"),
    loadLocaleFrom: (lang, ns) => {
        return import(`./locales/${lang}.json`).then((m) => m.default[ns]);
    },
};
